import React from 'react';
import { getPracticeState } from 'api/textVisit';
import { TPracticeState } from 'types/textVisit';

let globalData: TPracticeState[] | undefined = [];

const usePracticeStateList = (): [TPracticeState[] | undefined, boolean, () => void] => {
    const loading = React.useRef(false);
    const [items, setItems] = React.useState<TPracticeState[] | undefined>(globalData);
    const fetchData = async () => {
        try {
            loading.current = true;
            const result = await getPracticeState();
            if (!result.error) {
                const data: TPracticeState[] = result?.data?.data || [];
                globalData = data;
                setItems(data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (!loading.current) {
            fetchData();
        }
    }, []);

    return [items, loading.current, fetchData];
};

export default usePracticeStateList;
